import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';
import * as lookups from './lookups';
import * as AllMutates from './AllMutates';

export function updateMpiWorkItem(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
       dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateMpiWorkItemPage(id, key, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function sendMpiWorkItem(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function addMpiWorkItem(data, errorType) {
    return dispatch => Api.postData('mpi_work_items/', data).then((resp) => {
        dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
        const body = resp?.data;
        const record = body?.data || body;
        return record?.id;
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function createMpiReportPdf(vehicle_id, custom_form_id, errorType) {
	let data = {};
	data = {
		vehicle_id,
        custom_form_id,
	};
	return dispatch => Api.postData('mpi_reports/', data).then((resp) => {
		Promise.all([
			dispatch(lookups.activeVehicle(data.vehicle_id)),
		]).then(() => dispatch(getInfo.getWorkItemsByVidAndUpdate(data.vehicle_id)));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function createMpiReportPdfAndSend(vehicle_id, custom_form_id, errorType) {
	let data = {};
	data = {
		vehicle_id,
        custom_form_id,
        send_sftp: true,
	};
	return dispatch => Api.postData('mpi_reports/', data).then((resp) => {
		Promise.all([
			dispatch(lookups.activeVehicle(data.vehicle_id)),
		]).then(() => dispatch(getInfo.getWorkItemsByVidAndUpdate(data.vehicle_id)));
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteMpiWorkItem(id, errorType) {
    return dispatch => Api.delete(`mpi_work_items/${id}`).then(() => dispatch(getInfo.processDepartments())).catch(ex => Api.handleApiError(ex, errorType));
}



export function updateUviItem(id, data, errorType) {
    return (dispatch, getState) => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
       dispatch(lookups.activeVehicleWithPromise(data.vehicle_id));
    }).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateMpiItemRaw(id, data, errorType) {
    return dispatch => Api.patchData(`mpi_work_items/${id}`, data).then((resp) => {
    }).catch(ex => Api.handleApiError(ex, errorType));
}
